// These are global variables in the "design.tpl" file, make sure they are in sync
declare const __cartId: number;
declare let __cartReference: string;
declare let __productId: number;
declare const __customerId: number;
declare const __taxRate: number;
declare const __shopId: number;
declare const __virtualUri: string;
declare const __shopURL: string;
declare const __shopName: string;
declare let __productName: string;
declare let __savedTimestamp: number;
declare let __orderURL: string;
declare let __cartURL: string;
declare const __contactURL: string;
declare const __privacyURL: string;
declare let __loginWithDesignerBackLink: string;
declare let __isLoggedIn: boolean;
declare const __isAdmin: boolean;
declare const __isQuote: boolean;
declare const __quoteToken: string;
declare const __designerMode: string;
declare const __cartEndpoint: string;
declare const __employeeName: string;
declare const __customerLabel: string;

class PrestaGlobals {
    static get cartId(): number { return __cartId; }
    static get cartReference(): string { return __cartReference; }
    static set cartReference(reference: string) { __cartReference = reference; }
    static get productId(): number { return __productId; }
    static set productId(id: number) { __productId = id; }
    static get customerId(): number { return __customerId; }
    static get taxRate(): number { return __taxRate; }
    static get shopId(): number { return __shopId; }
    static get virtualUri(): string { return __virtualUri; }
    static get shopURL(): string { return __shopURL; }
    static get shopName(): string { return __shopName; }
    static get productName(): string { return __productName; }
    static set productName(name) { __productName = name; }
    static get savedTimestamp(): number { return __savedTimestamp; }
    static set savedTimestamp(timestamp) { __savedTimestamp = timestamp; }
    static get orderURL(): string { return __orderURL; }
    static set orderURL(url) { __orderURL = url; }
    static get cartURL(): string { return __cartURL; }
    static set cartURL(url) { __cartURL = url; }

    static get contactURL(): string { return typeof __contactURL !== 'undefined' && __contactURL ? __contactURL : '/contact'; }
    static get privacyURL(): string { return typeof __privacyURL !== 'undefined' ? __privacyURL : ''; }
    static get loginBackURL(): string { return __loginWithDesignerBackLink; }
    static set loginBackURL(loginWithDesignerBackLink) { __loginWithDesignerBackLink = loginWithDesignerBackLink; }
    static get isLoggedIn() { return __isLoggedIn; }
    /** True on the admin pages (/designeradmin, /ai-designer), set server-side for back-office employees. Gates the Configurator Admin UI only — never trust this for write authorization (the server re-checks). */
    static get isAdmin(): boolean { return typeof __isAdmin !== 'undefined' && !!__isAdmin; }
    /** Current cookie cart is a quote cart (read-only, Unity view only). */
    static get isQuote(): boolean { return typeof __isQuote !== 'undefined' && !!__isQuote; }
    // designer/q/<code> has no ?quote; server passes the route param
    static get quoteToken(): string {
        const fromServer = typeof __quoteToken !== 'undefined' ? __quoteToken : '';
        return fromServer || (new URLSearchParams(window.location.search).get('quote') ?? '');
    }
    /** True on the AI designer page (/ai-designer): the AI designer panel in the configurator's place. The server decides who gets the page. */
    static get isAiDesigner(): boolean { return typeof __designerMode !== 'undefined' && __designerMode === 'ai'; }
    /** UCC (customer) or UCCAdmin (admin pages) */
    static get cartEndpoint(): string { return typeof __cartEndpoint !== 'undefined' && __cartEndpoint ? __cartEndpoint : 'UCC'; }
    static cartUrl(method: string): string {
        return __virtualUri + '/index.php?fc=module&module=ubercart&controller=' + PrestaGlobals.cartEndpoint + '&method=' + method;
    }
    static get employeeName(): string { return typeof __employeeName !== 'undefined' ? __employeeName : ''; }
    /** Logged-in customer's e-mail, empty for a guest */
    static get customerLabel(): string { return typeof __customerLabel !== 'undefined' ? __customerLabel : ''; }
}

export default PrestaGlobals;
